import classNames from 'classnames';
import { MuteIndicatorIcon } from 'src/themes/cosmos/icons';

import styles from './styles.module.scss';

interface ISoundMuteIndicatorProps {
  volume: number;
}

const SoundMuteIndicator = ({ volume }: ISoundMuteIndicatorProps) => (
  <div className={styles.container}>
    <MuteIndicatorIcon
      data-testid='sound-mute-indicator'
      className={classNames(styles.muteIcon, {
        [styles.noSound]: volume < 1,
      })}
    />
  </div>
);

export default SoundMuteIndicator;
